import { Injectable } from '@angular/core';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { NotificationTemplate } from '@m4u-angular/base/entities/BaseEntities';
import { APIGatewayService } from '../gateway/APIGateway.service';

@Injectable()
export class NotificationTemplateEndpoint extends BaseEndpointCRUD<NotificationTemplate> {
    constructor(api: APIGatewayService) {super("NotificationTemplate", api);}
}